//视频实时流数据
<template>
    <div class="m-panelon">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
                <span style="position:absolute;top:5px;left:5%;">{{ $t('实时视频') }}</span>
                <img style="width: 20%;" :src="titleImage" />
            </div>
        </div>
        <div class="m-panel-bodying">
            <a-row style="height: 100%;">
                <a-col :span="24" style="height: 100%">
                    <a-row :gutter="16" style="height: 100%;margin: 0px;">
                        <!-- <a-col :span="4" style="text-align: center;">
                            <div class="ptz">
                                <a-collapse :activeKey="activeKey" expand-icon-position="right" style="text-align: left;">
                                    <a-collapse-panel key="1" header="组织树">
                                        <a-tree :selectedKeys="selectedKeys" :tree-data="treeData" :replace-fields="replaceFields" @select="TreeNodeClick" :defaultExpandAll="true" />
                                    </a-collapse-panel>
                                    <a-collapse-panel key="2" header="云台">
                                        <div class="ptz-block" :style="{'pointer-events': Channelnumber?.deviceType == 2?'':'none'}">
                                            <a-row>
                                                <a-col style="padding: 5px;" span="8" v-for="item in directOprions">
                                                    <a-tooltip>
                                                        <template #title>{{item.text}}</template>
                                                        <a-button shape="circle" @click="directionControl(item.direct,item.command)">
                                                            <Icon :icon="item.icon" :style="item.angle"></Icon>
                                                        </a-button>
                                                    </a-tooltip>
                                                </a-col>
                                            </a-row>
                                            <a-row>
                                                <a-col style="padding: 5px;" :span="8" v-for="item in directOperation">
                                                    <a-tooltip>
                                                        <template #title>{{item.text}}</template>
                                                        <Icon :icon="item.icon" style="font-size: 25px;" @click="directionOperation(item.direct,item.command,item.operateType)">
                                                        </Icon>
                                                    </a-tooltip>
                                                </a-col>
                                            </a-row>
                                        </div>
                                        <div class="yuzhi">
                                            <a-row>
                                                <a-col :span="24">
                                                    <a-collapse v-model:activeKey="activeKey" expandIconPosition="right" :bordered="false">
                                                        <a-collapse-panel key="5" style="text-align: left;" header="更多功能">
                                                            预置点：
                                                            <a-space>
                                                                <a-select ref="select" v-model:value="value1" style="width: 140px" placeholder="请选择预置点位">
                                                                    <a-select-option v-for=" item in Presettlist" :value="item.id" @click="handleChange(item)">
                                                                        {{item.presetPointName}}</a-select-option>
                                                                </a-select>
                                                            </a-space>
                                                        </a-collapse-panel>
                                                    </a-collapse>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </a-collapse-panel>
                                </a-collapse>
                            </div>
                        </a-col> -->
                        <a-col :span="20" style="text-align: center;">
                            <a-row :gutter="24" style="height: 100%;">
                                <a-col :span="24" style="height: 100%;position: relative">
                                    <DHPlayer videoId="testPlayer" ref="video1" :pathList="pathList" :shieldClass="['test_drop']" @getCurrentWindow="getCurrentWindow" @changeDivision="getDivisionNum" @picCap="picCap" @getError="getError">
                                    </DHPlayer>
                                </a-col>
                                <div class="error-tip" v-show="errorTip">{{ $t('错误提示') }}：{{errorTip}}</div>

                            </a-row>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
        </div>
    </div>
</template>
<script>
// import videojs from 'video.js';
// import 'video.js/dist/video-js.css'; //videojs样式
//import { Icon } from '@/components/Icon';
import DHPlayer from '@/components/DHPlayer/src/DHPlayer';

export default {
  components: { ArrowUpOutlined, SearchOutlined, Icon, DHPlayer },
  props: {
    titleImage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    player : null,
    player1 : null,
    player2 : null,
    // const player3 = ref(null);
    // const player4 = ref(null);
    // const player5 = ref(null);
    // const player6 = ref(null);
    // const activeKey = ref(['1']);
    // const videoList = ref([]);
    // const Presettlist = ref([]);
    // const treeData = ref([]);
    // //const checkedKeys = ref<string[]>(['1000405$1$0$0']);
    // const selectedKeys = ref<string[]>(['1000405$1$0$0']);
    // const replaceFields = {
    //   children: 'children',
    //   title: 'deviceName',
    //   key: 'channelId',
    // };
    Channelnumber : {},
    // const currentNum = ref(0);
    errorTip : '',
    divisionNum : 9,// 当前窗口的分割数量
    // const video1 = ref(null);
    srcUrlObj: [
        { key: 'video0', show: false, channelCode: '1000405%240', url: 'http://172.16.8.64:7086/live/cameraid/1000405%240/substream/2.m3u8' },
        { key: 'video1', show: false, channelCode: '1000405%241', url: 'http://172.16.8.64:7086/live/cameraid/1000404%241/substream/2.m3u8' },
        { key: 'video2', show: false, channelCode: '1000405%242', url: 'http://172.16.8.64:7086/live/cameraid/1000404%242/substream/2.m3u8' },
        { key: 'video3', show: false, channelCode: '1000405%243', url: 'http://172.16.8.64:7086/live/cameraid/100040%243/substream/2.m3u8' },
        { key: 'video4', show: false, channelCode: '1000405%244', url: 'http://172.16.8.64:7086/live/cameraid/1000404%244/substream/2.m3u8' },
        { key: 'video5', show: false, channelCode: '1000405%245', url: 'http://172.16.8.64:7086/live/cameraid/1000404%245/substream/2.m3u8' },
        { key: 'video6', show: false, channelCode: '1000405%246', url: 'http://172.16.8.64:7086/live/cameraid/1000404%246/substream/2.m3u8' },
      ],
      directOprions: [
        { direct: 5, command: 1, text: '左上', icon: 'ant-design:caret-left-outlined', angle: 'transform:rotate(45deg)' },
        { direct: 1, command: 1, text: '上', icon: 'ant-design:caret-up-outlined' },
        { direct: 7, command: 1, text: '右上', icon: 'ant-design:caret-up-outlined', angle: 'transform:rotate(45deg)' },
        { direct: 3, command: 1, text: '左', icon: 'ant-design:caret-left-outlined' },
        { direct: 1, command: 0, text: '暂停', icon: 'ant-design:pause-outlined' },
        { direct: 4, command: 1, text: '右', icon: 'ant-design:caret-right-outlined' },
        { direct: 6, command: 1, text: '左下', icon: 'ant-design:caret-down-outlined', angle: 'transform:rotate(45deg)' },
        { direct: 2, command: 1, text: '下', icon: 'ant-design:caret-down-outlined' },
        { direct: 8, command: 1, text: '右下', icon: 'ant-design:caret-right-outlined', angle: 'transform:rotate(45deg)' },
      ],
      directOperation: [
        { direct: 1, command: 1, operateType: 2, text: '变焦+', icon: 'ant-design:zoom-in-outlined' },
        { direct: 1, command: 1, operateType: 1, text: '变倍+', icon: 'ant-design:plus-square-outlined' },
        { direct: 1, command: 1, operateType: 3, text: '光圈+', icon: 'ant-design:plus-circle-outlined' },
        { direct: 2, command: 1, operateType: 2, text: '变焦-', icon: 'ant-design:zoom-out-outlined' },
        { direct: 2, command: 1, operateType: 1, text: '变倍-', icon: 'ant-design:minus-square-outlined' },
        { direct: 2, command: 1, operateType: 3, text: '光圈-', icon: 'ant-design:minus-circle-outlined' },
      ],
      PresetList: [
        { presetPointCode: 1, presetPointName: '预置点1', text: '预置点1', icon: '' },
        { presetPointCode: 2, presetPointName: '预置点2', text: '预置点2', icon: '' },
      ],
      pathList: [
        { path: 'rtsp://172.16.8.64:9090/dss/monitor/params?cameraid=1000405%240&substream=2&trackID=701 ', redirect: true },
        { path: 'rtsp://172.16.8.64:9090/dss/monitor/params?cameraid=1000405%241&substream=2&trackID=701 ', redirect: true },
        { path: 'rtsp://172.16.8.64:9090/dss/monitor/params?cameraid=1000405%242&substream=2&trackID=701 ', redirect: true },
        { path: 'rtsp://172.16.8.64:9090/dss/monitor/params?cameraid=1000405%243&substream=2&trackID=701 ', redirect: true },
        { path: 'rtsp://172.16.8.64:9090/dss/monitor/params?cameraid=1000405%244&substream=2&trackID=701 ', redirect: true },
        { path: 'rtsp://172.16.8.64:9090/dss/monitor/params?cameraid=1000405%245&substream=2&trackID=701 ', redirect: true },
        { path: 'rtsp://172.16.8.64:9090/dss/monitor/params?cameraid=1000405%246&substream=2&trackID=701 ', redirect: true },
      ],
      url: {
        iccVideoCtrl:'/video/iccVideoCtrl/videoDirect',
        videoCameraLens:'/video/iccVideoCtrl/videoCameraLens',
        videoList : '/video/videoChannelRecord/list',
        videoCameraPresetPositionOperate:'/video/iccVideoCtrl/videoCameraPresetPositionOperate',
        Presetpointlist:'/video/videoPresetPoint/list'
      }
    }
  },

    // 接口查询
    mounted()  {
      this.nextTick(() => {
        this.queryVideoList();
        //getvideo();
      });
    },
    methods:{
    //   getvideo () {
    //     let options = {
    //       bigplaybutton: true,
    //       texttrackdisplay: false,
    //       posterimage: true,
    //       poster: '', // 视频的缩略图，未播放时显示的图片
    //       errordisplay: false,
    //       language: 'zh-CN', // 设置语言
    //       fluid: true, // 自适应宽高
    //       controlbar: {
    //         fullscreenToggle: true,
    //         // 音量条的横向还是纵向显示
    //         volumePanel: {
    //           inline: false,
    //         },
    //       },
    //     };
    //     player.value = videojs('video0', options, function () {
    //       this.play();
    //     });
    //     player1.value = videojs('video1', options, function () {
    //       this.play();
    //     });
    //     player2.value = videojs('video2', options, function () {
    //       this.play();
    //     });
    //     player3.value = videojs('video3', options, function () {
    //       this.play();
    //     });
    //     player4.value = videojs('video4', options, function () {
    //       this.play();
    //     });
    //     player5.value = videojs('video5', options, function () {
    //       this.play();
    //     });
    //     player6.value = videojs('video6', options, function () {
    //       this.play();
    //     });
    //   },
    //   changeVideoUrl(url) {
    //   player.src(url);
    //   player.play();
    // },
    // 接口请求
    async queryVideoList() {
      console.log('请求视频接口');
      this.treeData = [];
      try {
        getAction(this.url.videoList, params).then((res) => {
          if(res.success){
            let result = res.result;
            console.log(result);
            if (result || result.length > 0) {
              // data.srcUrlObj = result.records
              this.treeData.push({
                deviceName: '172.16.8.63',
                key: '0-0',
                children: result.records,
              });
              console.log('列表', treeData.value);
            }
          }
        })
        
      } catch (error) {}
    },
    //树节点 点击
    TreeNodeClick(key, e) {
      console.log('啦啦：' + key);
      this.Channelnumber = e.node.dataRef;
      this.Presetpoint();
      this.currentNum = e.node.dataRef.channelId.substr(-1);
      console.log(selectedKeys.value);
      //selectedKeys.value.splice(0,1,key);
      // 选中窗口
      this.video1.videoPlayer.chooseWindow(currentNum.value);
    },
    //预置点位请求
    async Presetpoint(data) {
      try {
         getAction(this.url.Presetpointlist, { channelId: this.Channelnumber.channelId }).then((res) => {
          const result = res.result;
          if (result || result.records.length > 0) {
            this.Presettlist = result.records;
          }
         })
        
      } catch (error) {}
    },
    directionControl(direct, command) {
      console.log(videoList);
      let params = { direct: direct, command: command, channelCode: Channelnumber.value.channelId, stepX: 1, stepY: 1 };
      this.iccVideoCtrl(params);
      console.log('方向控制', params);
    },
    directionOperation(direct, command, operateType) {
      console.log(videoList);
      let params = { direct: direct, command: command, operateType: operateType, channelCode: Channelnumber.value.channelId, step: 2 };
      this.videoCameraLens(params);
      console.log('缩放控制', params);
    },
    PresetOperation(presetPointCode, presetPointName) {
      let params = { presetPointCode: presetPointCode, presetPointName: presetPointName, channelCode: Channelnumber.value.channelId };
      this.videoCameraPresetPositionOperate(params);
      console.log('预置点位', params);
    },
    videotabs(item) {
      this.Presetpoint(item.channelId);
      console.log('点击选中', item.channelId);
    },
    handleChange(item) {
      this.PresetOperation(item.presetPointCode, item.presetPointName);
      console.log('毁掉', item);
    },
    //获取当前选中的窗口
    getCurrentWindow(num) {
      this.selectedKeys = ['1000405$1$0$' + num];
      this.currentNum = num;
    },
    // 控件切换窗口数量时返回前端告知当前多少窗口
    getDivisionNum(v) {
      this.divisionNum = v;
    },
    downloadFile(url, name = new Date().valueOf()) {
      var a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('download', name);
      a.setAttribute('target', '_blank');
      let clickEvent = document.createEvent('MouseEvents');
      clickEvent.initEvent('click', true, true);
      a.dispatchEvent(clickEvent);
    },
    picCap({ path }) {
      this.downloadFile(path, 'image_' + new Date().valueOf());
    },
    getError(error) {
      this.errorTip = error;
    }
    }
  }
</script>

<style lang="less" scoped>
.video-js {
  height: 90% !important;
  width: 100% !important;
  object-fit: fill !important;
}

.ptz {
  width: 100%;
  .ptz-block {
    width: 60%;
    margin: 0 auto;
  }

  .yuzhi {
    width: 100%;
    margin: 0 auto;
  }
}

:deep(.video-js .vjs-tech) {
  border: 0px !important;
}

:deep(.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar) {
  display: none;
  pointer-events: none !important;
}

.app {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
:deep(.ant-collapse > .ant-collapse-item) {
  border-bottom: 0px;
}

:deep(.ant-collapse-content > .ant-collapse-content-box) {
  padding: 5px;
}

:deep(#testPlayer) {
  width: 100%;
  height: 100%;
  border: 1px solid #000;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.m-panel-bodying {
  margin-top: 10px;
  height: calc(100% - 200px);
}
.m-panelon {
  color: #ffffff;
  height: 100%;
  width: 100%;
  background: #062121;
}
:deep(.ant-collapse){
    background: transparent;
    color: #76BCE8;
    border:0;
}
:deep(.ant-collapse > .ant-collapse-item > .ant-collapse-header){
    color: #76BCE8;
}
:deep(.ant-collapse-content){
    background: transparent;
    border-top:0;
    color: #76BCE8;
}
:deep(.ant-tree li .ant-tree-node-content-wrapper){
    color: #76BCE8;
}
:deep(.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon){
    color: #76BCE8;
}
:deep(.ant-btn){
    background: transparent;
    border: 1px solid #76BCE8;
}
:deep(.ant-btn .anticon){
    color: #76BCE8;
}
</style>